import styled from 'styled-components';

import { H4Typography } from '../../elements/Typography';

const Header = styled(H4Typography)`
  @media (min-width: ${(props) => props.theme.breakpoints.xs}) {
    > *:last-child {
      position: relative;
      width: fit-content;
      z-index: 1;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        border-bottom: 10px solid ${(props) => props.theme.colors.brandBlue50};
        z-index: -1;
      }
    }
  }
`;

export default Header;
